<template>
    <form @submit.prevent="submit" action="" class="max-w-xs mx-auto">
        <div class="form-group mb-3">
            <input
                :class="{'auth-input': true, 'is-invalid': errors.has('email')}"
                v-validate="'required|email'"
                name="email"
                :placeholder="translate('auth_forgot_password_placeholder_email')"
                v-model="form.email"
                type="email">
            <div class="invalid-feedback">
                <span v-if="errors.has('email')" class="has-error text-center">{{ errors.first('email') }}</span>
            </div>
        </div>
        <div class="form-group mb-3">
            <button class="auth-input button button-success">{{ translate('auth_forgot_password_button_send') }}</button>
        </div>

        <div class="form-group text-center">
            <a class="text-sm no-underline text-black shadow-text-none" @click.prevent="toggleLogin" href="#">{{ translate('auth_button_back_login') }}</a>
        </div>

    </form>
</template>

<script>
import Request from '@/lib/request.js'
import appConfig from '@/app.config.js'
import popup from '@/lib/popup'
import helperMixins from '@/mixins/helper.js'

export default {
    name: 'ForgotPasswordForm',

    data () {
        return {
            form: {
                email: ''
            }
        }
    },

    mixins: [
        helperMixins
    ],

    methods: {
        toggleLogin () {
            this.$emit('toggle-login')
        },

        submit () {
            this.$validator.validate().then((result) => {
                if (!result) {
                    return
                }

                this.$emit('try-reset-password')

                const request = new Request

                request.post(appConfig.api.createResetPasswordToken, this.form)
                    .then(() => {
                        this.$emit('sent-request')
                        popup.alert(this.translate('auth_forgot_password_alert_sent_email_reset'), () => {
                            this.$emit('sent-request-success')
                        })
                    })
                    .catch((err) => {
                        this.$emit('sent-request')

                        if (err.response.status == 500) {
                            return popup.alert(err.response.data.message, () => {
                                this.$emit('sent-request-fail')
                            })
                        }

                        popup.alert(this.translate('auth_forgot_password_alert_email_not_exists'), () => {
                            this.$emit('sent-request-fail')
                        })
                    })
            })
        }
    }
}
</script>
